import type { MultilingualConfigValue, MultilingualNodeConfig } from "../../schemas/index.ts";
import { isMultilingualProperty } from "./filterFunctions.ts";

interface Options {
  lang: string;
}

export const removeTranslationCreate = ({ lang }: Options) => {
  const removeTranslation = (value: MultilingualConfigValue): MultilingualConfigValue => {
    if (!value) {
      return value;
    }

    if (Array.isArray(value)) {
      return value.map(removeTranslation);
    }

    if (typeof value === "object") {
      if (isMultilingualProperty(value)) {
        const { [lang]: _, ...remainingTranslations } = value.__ml;
        return {
          __ml: remainingTranslations,
        };
      }

      return Object.fromEntries(Object.entries(value).map(([name, propValue]) => [name, removeTranslation(propValue)]));
    }
    return value;
  };

  return (config: MultilingualNodeConfig) =>
    Object.fromEntries(
      Object.entries(config).map(([name, value]): [string, MultilingualConfigValue] => [
        name,
        removeTranslation(value),
      ]),
    );
};
